module.exports = __webpack_public_path__ + "img/theater1.d5139b1c.jpg";